module.exports = __webpack_public_path__ + "fonts/mem5YaGs126MiZpBA-UNirkOX-hpOqc.76563ea1.woff2";